<div class="grid my-4 gap-y-5">
  @if (!lightMode()) {
    <lib-product-card-chips [chipLabels]="chipLabels()"></lib-product-card-chips>
  }
  @if (hasPromotion() && hasDiscountedCost()) {
    <lib-product-card-price
      data-testid="product-price-discounted"
      [price]="product().monthly_cost"
      [discountedPrice]="discountedPrice()"
      [discountLabel]="'- ' + discountPercentage() + ' %'"
      [isNavProduct]="isNavProduct()"
    />
  } @else {
    <lib-product-card-price
      data-testid="product-price"
      [isNavProduct]="isNavProduct()"
      [price]="product().monthly_cost"
    />
  }
</div>
